VjsAdmin.WebinarDatesBuilder = (function () {
    const init = function () {
        VjsAdmin.initDateRangePickers('#webinar-dates-form', true);
        $('#generate-dates').on('click', generateDates);
        $('#copy-to-clipboard').on('click', copyDivToClipboard);
    };

    function generateDates() {
        const selectedDate = $('#datepicker').val();
        const count = $('#number-of-dates').val();

        if (selectedDate === '' || count === '') {
            // eslint-disable-next-line no-new, new-cap
            new PNotify.notice({
                title: 'Missing data',
                text: 'All the fields are required',
                icon: 'fa fa-exclamation-triangle',
                type: 'error',
            });
            return false;
        }

        if (count > 250) {
            // eslint-disable-next-line no-new, new-cap
            new PNotify.notice({
                title: 'Max Exceeded',
                text: 'The max number of dates is 250',
                icon: 'fa fa-exclamation-triangle',
                type: 'error',
            });
            return false;
        }

        $('#webinar-dates').empty();

        let newDate = moment(selectedDate);
        newDate.set({ hour: 8, minute: 0 });

        showDate(newDate);
        for (let i = 0; i <= count - 2; i++) {
            newDate = nextWebinar(newDate);
            showDate(newDate);
        }

        $('#copy-to-clipboard').show();
        $('.delete-row').on('click', (e) => {
            const row = $(e.currentTarget).closest('.date-row');
            row.remove();
        });
    }

    function showDate(dateWebinar) {
        $('#webinar-dates').append(
            `<div class='date-row'>${dateWebinar.format('dddd, MMMM Do [at] h:mm A')}<i class='fa fa-times delete-row pull-right' /></div>`,
        );
    }

    function nextWebinar(initDate) {
        const resultDate = initDate.add({ minutes: 30 });

        if (resultDate.hour() > 16) {
            // if Friday
            if (+resultDate.day() === 5) {
                //  Move to Monday
                resultDate.add({
                    days: 3,
                });
            } else {
                // If not Friday, move to next day
                resultDate.add({
                    days: 1,
                });
            }

            // reset to 8AM
            resultDate.hour(8);
        }

        return resultDate;
    }

    function copyDivToClipboard() {
        const range = document.createRange();
        range.selectNode(document.getElementById('webinar-dates'));
        window.getSelection().removeAllRanges(); // clear current selection
        window.getSelection().addRange(range); // to select text
        document.execCommand('copy');
        window.getSelection().removeAllRanges(); // to deselect
        // eslint-disable-next-line no-new, new-cap
        new PNotify.info({
            title: 'Copied to clipboard',
            text: 'Now you can paste it to excel',
            icon: 'fa fa-info-circle',
            type: 'notice',
        });
    }

    return {
        init,
    };
}());
